// frontend/src/pages/PublicDashboard.jsx
// Este componente agora redireciona para o ServiceDashboard em modo público
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PublicDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirecionar para modo público do ServiceDashboard
    navigate('/services?mode=public', { replace: true });
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
        <p className="text-muted">Redirecionando para o Painel de Serviços...</p>
      </div>
    </div>
  );
}
